module.exports = __webpack_public_path__ + "static/media/rebookService.96a50b5f.svg";